import { RowSelectionState, ColumnDef } from '@tanstack/react-table'
import { ClientDataTable } from 'components/ClientDataTable/ClientDataTable'
import { Dispatch, SetStateAction, useMemo } from 'react'
import { CSVRow, InternalColumns } from '../importer-types'

export function ImportWizardConfirmMatchedStep({
  show,
  headers,
  setRowSelection,
  rowSelection,
  data,
}: {
  show: boolean
  headers: Record<string, string>
  setRowSelection: Dispatch<SetStateAction<RowSelectionState>>
  rowSelection: RowSelectionState
  data: CSVRow[]
}) {
  const columnDefs: ColumnDef<CSVRow>[] = useMemo(() => {
    return [
      {
        id: 'input_data',
        header: 'Input Data',
        cell: ({ row }) => {
          const assembledAddress = [
            row.original[headers.street],
            row.original[headers.city],
            row.original[headers.state],
            row.original[headers.zip],
          ]
            .filter(Boolean)
            .join(', ')

          const name = row.original[headers.name] || '-'
          const domain = row.original[headers.domain] || '-'
          const address =
            row.original[headers.full_address] || assembledAddress || '-'

          return (
            <div className="space-y-0.5 text-sm">
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Name:</span> {name}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Domain:</span>{' '}
                {domain}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Address:</span>{' '}
                {address}
              </div>
            </div>
          )
        },
      },
      {
        id: 'matched_data',
        header: 'Matched Data',
        cell: ({ row }) => {
          const chain = row.original.__internal__matched_chain
          const door = row.original.__internal__matched_door

          const name = door?.name || chain?.name || '-'
          const domain = door?.domain || chain?.domain || '-'
          const address = door?.address || '-'

          return (
            <div className="space-y-0.5 text-sm">
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Name:</span> {name}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Domain:</span>{' '}
                {domain}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Address:</span>{' '}
                {address}
              </div>
            </div>
          )
        },
      },
    ]
  }, [headers])

  if (!show) {
    return null
  }

  return (
    <ClientDataTable
      selectedRows={rowSelection}
      onRowSelectionChange={setRowSelection}
      data={data}
      height={'100%'}
      columns={columnDefs}
      enableSorting
      enableRowSelection
      invertedRowSelection
      selectionRowID={InternalColumns.COMPANY_HASH}
    />
  )
}
